import { render } from "./ThePlatform.vue?vue&type=template&id=3fc3e5de&scoped=true&lang=html"
import script from "./ThePlatform.vue?vue&type=script&lang=js"
export * from "./ThePlatform.vue?vue&type=script&lang=js"

import "./ThePlatform.vue?vue&type=style&index=0&id=3fc3e5de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc3e5de"]])

export default __exports__